import ajax from './ajax'
//获取工具类目
export const listToolCate = (data)=>ajax('/portal/groupList', data, "GET");
//获取工具类目icon
export const listToolIcon = (data)=>ajax('/portal/tooIcon', data, "GET");
//获取工具详细信息
export const getToolInfo = (id)=>ajax('/portal/getToolInfo/' + id, "GET");
//获取工具菜单
export const searchTool = (keyWord)=>ajax('/tTool/list', {'page': 1, 'limit': 10000, 'title': keyWord }, "POST");
//获取时区
export const listZoon = ()=>ajax('/portal/zoonList');
//获取右侧菜单
export const listRightMenu = ()=>ajax('/portal/rightMenuList');
//获取右侧菜单icon
export const listRightMenuIcon = ()=>ajax('/portal/rightMenuIcon');
//获取顶部菜单
export const listHead = ()=>ajax('/portal/listHead', {}, "POST");
//获取顶部菜单
export const getHeadInfo = (id)=>ajax('/portal/getHeadInfo/' + id, "GET");




// WEBPACK FOOTER //
// ./src/api/index.js